export enum MixPanelEvents {
  APP_INSIGHTS_ENTER_SCREEN = 'App Insights - Enter Screen',
  AUTHENTICATION_FAILURE = 'AUTHENTICATION_FAILURE',
  AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS',
  DEVICES_ENTER_SCREEN = 'Devices - Enter Screen',
  BELL_LOGIN_PAGE_ENTER_SCREEN = 'Bell Login Page - Enter Screen',
  EMPLOYEE_CREATE_SUCCESS = 'EMPLOYEE_CREATE_SUCCESS',
  EMPLOYEE_LOGIN_ENABLEMENT = 'EMPLOYEE_LOGIN_ENABLEMENT',
  EMPLOYEE_LOGIN_SELFHEAL = 'EMPLOYEE_LOGIN_SELFHEAL',
  EMPLOYEE_REMOVE_SUCCESS = 'EMPLOYEE_REMOVE_SUCCESS',
  EMPLOYEE_UNBLOCK_SUCCESS = 'EMPLOYEE_UNBLOCK_SUCCESS',
  EMPLOYEE_LOGIN_ENTER_SCREEN = 'Employee Login - Enter Screen',
  EMPLOYEES_ENTER_SCREEN = 'Employees - Enter Screen',
  EMPLOYEE_ZONE_ENTER_SCREEN = 'Employee Zone - Enter Screen',
  EXTERNAL_INSURANCE_FAILED = 'EXTERNAL_INSURANCE_FAILED',
  GLOBAL_AUTH_PAGE_ENTER_SCREEN = 'Global Auth Page - Enter Screen',
  GUEST_DOWNLOAD_CSV_FAILURE = 'GUEST_DOWNLOAD_CSV_FAILURE',
  GUEST_DOWNLOAD_CSV_MESSAGE = 'GUEST_DOWNLOAD_CSV_MESSAGE',
  GUEST_DOWNLOAD_CSV_SUCCESS = 'GUEST_DOWNLOAD_CSV_SUCCESS',
  GUEST_DOWNLOAD_NO_EMAILS_MESSAGE = 'GUEST_DOWNLOAD_NO_EMAILS_MESSAGE',
  GUEST_DOWNLOAD_TURN_ON_FAILURE = 'GUEST_DOWNLOAD_TURN_ON_FAILURE',
  GUEST_DOWNLOAD_TURN_ON_MESSAGE = 'GUEST_DOWNLOAD_TURN_ON_MESSAGE',
  GUEST_DOWNLOAD_TURN_ON_SUCCESS = 'GUEST_DOWNLOAD_TURN_ON_SUCCESS',
  GUEST_ZONE_ENTER_SCREEN = 'Guest Zone - Enter Screen',
  HOME_ENTER_SCREEN = 'Home - Enter Screen',
  INSURANCE_ENTER_SCREEN = 'Insurance - Enter Screen',
  INSURANCE_IFRAME_ENTER_SCREEN = 'Insurance IFrame - Enter Screen',
  INTRO_PAGE_ENTER_SCREEN = 'Intro Page - Enter Screen',
  LOCATIONS_ENTER_SCREEN = 'Locations - Enter Screen',
  LOCATION_CHANGED = 'LOCATION_CHANGED',
  LOCATION_SUMMARY = 'LOCATION_SUMMARY',
  LOGIN_PAGE_ENTER_SCREEN = 'Login Page - Enter Screen',
  LOGOUT = 'LOGOUT',
  MAGIC_LINK_PAGE_ENTER_SCREEN = 'Magic Link Page - Enter Screen',
  NETWORK_ENTER_SCREEN = 'Network - Enter Screen',
  PARTNER_AUTHENTICATION_CALLBACK_ENTER_SCREEN = 'Partner Authentication Callback - Enter Screen',
  RESET_PASSWORD_PAGE_ENTER_SCREEN = 'Reset Password Page - Enter Screen',
  SECURE_ZONE_ENTER_SCREEN = 'Secure Zone - Enter Screen',
  SETTINGS_ACCOUNT_ENTER_SCREEN = 'Settings - Account - Enter Screen',
  SETTINGS_BUSINESS_INFO_ENTER_SCREEN = 'Settings - Business Info - Enter Screen',
  SETTINGS_EMPLOYEE_ENTER_SCREEN = 'Settings - Employee - Enter Screen',
  SETTINGS_EMPLOYEE_LOGIN_ENTER_SCREEN = 'Settings - Employee Login - Enter Screen',
  SETTINGS_GUEST_ENTER_SCREEN = 'Settings - Guest - Enter Screen',
  SETTINGS_INDEX_ENTER_SCREEN = 'Settings - Index - Enter Screen',
  SETTINGS_PODS_ENTER_SCREEN = 'Settings - Pods - Enter Screen',
  SETTINGS_SECURE_ENTER_SCREEN = 'Settings - Secure - Enter Screen',
  SETTINGS_SHIELD_ENTER_SCREEN = 'Settings - Shield - Enter Screen',
  SETTINGS_SUPPORT_ENTER_SCREEN = 'Settings - Support - Enter Screen',
  SHIELD_ENTER_SCREEN = 'Shield - Enter Screen',
  SSID_CONFIGURATION_ENTER_SCREEN = 'SSID Configuration - Enter Screen',
  UNQUARANTINE_DEVICE = 'UNQUARANTINE_DEVICE',
  WLAN_VIEW_ALL_ENTER_SCREEN = 'Wlan View All - Enter Screen',
}
